<template>
    
    <div style="margin-left: 10%; margin-top:43px; background-color:white; width: 80%; min-height: 600px; border-radius: 10px; border:2px solid lightgrey ;box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)">
        <el-page-header @back="goBack" content="详情页面" style="padding: 10px;">
        </el-page-header>
        <h1 v-show="this.$route.query.id !== undefined" align="center" style="padding: 20px;">现在是修改题目页面</h1>
        <h1 v-show="!isOpen" style="padding: 20px;">{{ pbid }} -- {{ name }} </h1>
        <h1 v-show="isOpen" style="padding: 20px;"> 
            <el-input
            placeholder="id"
            v-model="pbid"
            clearable style="width: 100px;">
            </el-input>
             --  
            <el-input
            placeholder="name"
            v-model="name"
            clearable style="width: 200px;">
            </el-input>
        </h1>
        <el-tabs type="border-card">
            <el-tab-pane>
                <span slot="label"> <i class="el-icon-date"></i>  题目 </span>
                <!-- 这里是题目内容 -->
                <div class="contain">
                    <div class="row" style="height: auto;">
                        <div class="col-9">
                            <div class="content" v-show="!isOpen">{{ problemcontent }}</div>
                            <div class="content" v-show="isOpen">
                                <el-input
                                type="textarea"
                                :rows="8"
                                placeholder="problemcontent"
                                v-model="problemcontent"
                                clearable style="width: 850px;">
                                </el-input>
                            </div>
                            <h4>输入格式:</h4>
                            <div class="h4-2" v-show="!isOpen">{{ input }}</div>
                            <div class="h4-2" v-show="isOpen">
                                <el-input
                                type="textarea"
                                :rows="6" 
                                placeholder="input"
                                v-model="input"
                                clearable style="width: 800px;">
                                </el-input>
                            </div>
                            <h4>输出格式:</h4>
                            <div class="h4-2" v-show="!isOpen">{{ output }}</div>
                            <div class="h4-2" v-show="isOpen">
                                <el-input
                                type="textarea"
                                :rows="6" 
                                placeholder="output"
                                v-model="output"
                                clearable style="width: 800px;">
                                </el-input>
                            </div>
                            <h4>数据范围</h4>
                            <div class="h4-1" v-show="!isOpen">{{ range }}</div>
                            <div class="h4-1" v-show="isOpen">
                                <el-input
                                type="textarea"
                                :rows="4" 
                                placeholder="range"
                                v-model="range"
                                clearable style="width: 300px;">
                                </el-input>
                            </div>
                            <h4>输入样例:</h4>
                            <pre class="pre-1" v-show="!isOpen">{{ inexample }}</pre>
                            <pre class="pre-1" v-show="isOpen">
                                <el-input
                                type="textarea"
                                :rows="6" 
                                placeholder="inexample"
                                v-model="inexample"
                                clearable style="width: 800px;">
                                </el-input>
                            </pre>
                            <h4>输出样例:</h4>
                            <pre class="pre-1" v-show="!isOpen">{{ outexample }}</pre>
                            <pre class="pre-1" v-show="isOpen">
                                <el-input
                                type="textarea"
                                :rows="6" 
                                placeholder="outexample"
                                v-model="outexample"
                                clearable style="width: 800px;">
                                </el-input>
                            </pre>
                        </div>
                        <div class="col-3" style=" box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); max-height: 200px;">
                            <table class="table table-striped table-hover">
                                <tbody style="font-size:15px">
                                    <tr class="TR" v-show="!isOpen">
                                        难度: {{ difficulty }}
                                    </tr>
                                    <tr v-show="isOpen">
                                        <el-input
                                        placeholder="difficulty"
                                        v-model="difficulty"
                                        clearable style="width: 200px;">
                                        </el-input>
                                    </tr>
                                    <tr class="TR" v-show="!isOpen">
                                        时/空要求: {{ tm }}
                                    </tr>
                                    <tr v-show="isOpen">
                                        <el-input
                                        placeholder="tm"
                                        v-model="tm"
                                        clearable style="width: 200px;">
                                        </el-input>
                                    </tr>
                                    <tr class="TR" v-show="!isOpen">
                                        来源: {{ pbfrom }}
                                    </tr>
                                    <tr v-show="isOpen">
                                        <el-input
                                        placeholder="pbfrom"
                                        v-model="pbfrom"
                                        clearable style="width: 200px;">
                                        </el-input>
                                    </tr>
                                    <tr class="TR" v-show="!isOpen">
                                        算法标签: {{ altag }}
                                    </tr>
                                    <tr v-show="isOpen">
                                        <el-input
                                        placeholder="altag"
                                        v-model="altag"
                                        clearable style="width: 200px;">
                                        </el-input>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div style="margin-top:40px; float:right" >
                        <el-button type="danger" icon="el-icon-delete" circle v-show="this.$route.query.id !== undefined" @click="ClickMeToDel"></el-button>
                        <el-button type="primary" icon="el-icon-edit" circle @click="ClickMeToUpdate"></el-button>
                        <el-button type="success" icon="el-icon-check" circle @click="accept"></el-button>
                        <el-button type="warning" round @click="ClickMeToSubmit">提交咯</el-button>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import $ from 'jquery'

    export default {
        name:'QuestionTemplate',
        data() {
            return {
                isOpen: false,
                id:'',
                pbid: '2',
                name: '01背包问题',
                difficulty: '简单',
                altag: '01背包',
                problemcontent: '有 N件物品和一个容量是 V的背包。每件物品只能使用一次。第 i件物品的体积是 vi，价值是 wi。求解将哪些物品装入背包，可使这些物品的总体积不超过背包容量，且总价值最大。输出最大价值。',
                input: '第一行两个整数，N，V，用空格隔开，分别表示物品数量和背包容积。接下来有 N行，每行两个整数 vi,wi，用空格隔开，分别表示第 i件物品的体积和价值。', 
                output: '输出一个整数，表示最大价值。',
                inexample: '4 5\n1 2\n2 4\n3 4\n4 5',
                outexample: '8',
                range: '0 < N, V ≤ 10000 < vi , wi ≤ 1000',
                tm: '1s / 64MB',
                pbfrom:'Acwing',
            }
        },
        mounted() {
            if (this.$route.query.id !== undefined) { 
                // 说明此时是修改题目
                this.id = this.$route.query.id
                this.pbid = this.$route.query.pbid
                this.name = this.$route.query.name
                this.difficulty = this.$route.query.difficulty
                this.altag = this.$route.query.altag
                this.problemcontent = this.$route.query.problemcontent
                this.input = this.$route.query.input
                this.output = this.$route.query.output
                this.inexample = this.$route.query.inexample
                this.outexample = this.$route.query.outexample
                this.range = this.$route.query.range
                this.tm = this.$route.query.tm
                this.pbfrom = this.$route.query.pbfrom
            }
        },
        methods: {
            goBack() {
                this.$router.push('/MyInfomation/manage')
            },
            ClickMeToUpdate() { // 开始修改捏
                this.isOpen = true;
            },
            accept() { // 保存
                this.isOpen = false;
            },
            ClickMeToSubmit() { // 把数据提交给后端
                const data = this
                const store = this.$store

                if (this.$route.query.id === undefined) { // 说明是增加题目
                    $.ajax({
                        url: "https://app6132.acapp.acwing.com.cn/api/question/add/",
                        type: "post",
                        headers: {
                            Authorization: "Bearer " + store.state.me.token
                        },
                        data: { // 传给后端11条信息
                            pbid: data.pbid.trim(),
                            name: data.name.trim(),
                            difficulty: data.difficulty.trim(),
                            altag: data.altag.trim(),
                            problemcontent: data.problemcontent.trim(),
                            input: data.input.trim(),
                            output: data.output.trim(),
                            inexample: data.inexample.trim(),
                            outexample: data.outexample.trim(),
                            range: data.range.trim(),
                            tm: data.tm.trim(),
                            pbfrom: data.pbfrom.trim(),
                        },
                        success(resp) {
                            if (resp.error_message === "success") {
                                console.log("添加成功了")
                                /* 这里等下写更新Vuex的question */
                                // store.dispatch("problem/GetQuestionList");
                            } else {
                                console.log(resp.error_message)
                                // store.dispatch("problem/GetQuestionList");
                            }
                        },
                        error(resp) {
                            console.log("添加失败了， resp == > ", resp)
                        }
                    })
                } else { // 说明是修改信息
                    $.ajax({
                        url: "https://app6132.acapp.acwing.com.cn/api/question/update/",
                        type: "post",
                        headers: {
                            Authorization: "Bearer " + store.state.me.token
                        },
                        data: { // 传给后端11条信息
                            id: data.id.trim(),
                            pbid: data.pbid.trim(),
                            name: data.name.trim(),
                            difficulty: data.difficulty.trim(),
                            altag: data.altag.trim(),
                            problemcontent: data.problemcontent.trim(),
                            input: data.input.trim(),
                            output: data.output.trim(),
                            inexample: data.inexample.trim(),
                            outexample: data.outexample.trim(),
                            range: data.range.trim(),
                            tm: data.tm.trim(),
                            pbfrom: data.pbfrom.trim(),
                        },
                        success(resp) {
                            if (resp.error_message === "success") {
                                console.log("修改成功了")
                                /* 这里等下写更新Vuex的question */
                                // store.dispatch("problem/GetQuestionList");
                            } else {
                                console.log("后端收到了但 resp == > ", resp.error_message)
                                // store.dispatch("problem/GetQuestionList");
                            }
                        },
                        error(resp) {
                            console.log("添加失败了， resp == > ", resp)
                        }
                    })
                }
            },
            ClickMeToDel() {
                this.$confirm('此操作将永久删除该题目, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const store = this.$store
                    const route = this.$route
                    const message = this.$message
                    $.ajax({
                        url:"https://app6132.acapp.acwing.com.cn/api/question/delete/",
                        type:'post',
                        headers: {
                            Authorization: "Bearer " + store.state.me.token,
                        },
                        data: {
                            id: route.query.id
                        },
                        success(resp) {
                            console.log("删除成功辣, resp == > ", resp.error_message)
                            message({
                                type: 'success',
                                message: '删除成功! 3秒后自动关闭页面'
                            });
                            setTimeout(() => {
                                window.close()
                            }, 3000);
                        },
                        error(resp) {
                            console.log("删除失败啦, resp == > ", resp)
                            message({
                                type: 'warning',
                                message: '删除失败了....'
                            });
                        }
                    })
                }).catch(() => {
                    message({
                        type: 'info',
                        message: '已取消删除'
                    });          
                });
            }
        }
    }
</script>

<style scoped>
.contain {
    height: auto;
}
.content {
    width:850px;
    padding: 20px 0 20px 0;
    font-size:15px;
    overflow: hidden;
    min-height: 20px;
    height: auto;
    white-space: pre-wrap; /*css-3*/ 
    word-wrap: break-word; /*InternetExplorer5.5+*/ 
}
.TR {
    min-height: 20px;
    min-width: 100px;
    height: 5vh;
    display: flex;
    padding-top: 1vh;
    /* align-content: center; */
}
h4 {
    font-size: 16px;
    font-weight:600; 
    width:100%; 
    padding-top:4px;
}
.h4-1 {
    overflow: hidden;
    font-size: 14px;
    min-width: 200px;
    max-width: 400px;
    min-height: 20px;
    height: auto;
    padding-top:2px;
    height: auto;
    white-space: pre-wrap; /*css-3*/ 
    word-wrap: break-word; /*InternetExplorer5.5+*/ 
    padding-bottom: 4px;
}
.h4-2 {
    overflow: hidden;
    font-size: 14px;
    min-width: 200px;
    max-width: 800px;
    min-height: 20px;
    height: auto;
    padding-top:2px;
    height: auto;
    white-space: pre-wrap; /*css-3*/ 
    word-wrap: break-word; /*InternetExplorer5.5+*/ 
    padding-bottom: 4px;
}
.pre-1 {
    overflow: hidden;
    font-size: 15px;
    width: 820px;
    min-height: 20px;
    height: auto;
    padding-top:2px;
    height: auto;
    white-space: pre-wrap; /*css-3*/ 
    word-wrap: break-word; /*InternetExplorer5.5+*/ 
}
</style>